import React from "react";
import PropTypes from "prop-types";
import SimpleVirtualizedAutocomplete from "../../../../../../../../components/Dropdown/SimpleVirtualizedAutocomplete";
import { VIEW_COLUMNS } from "../../../../config/customerColumnsConfig";

const AddCustomerRow = ({
  customerOptions,
  addCustomer,
  newCustomerId,
  setNewCustomerId,
}) => {
  const handleOnChange = (event, newValue) => {
    if (newValue) {
      setNewCustomerId(newValue.customerID);
      addCustomer(newValue.customerID);
      setNewCustomerId(""); // Clear selection after adding.
    } else {
      setNewCustomerId("");
    }
  };

  return (
    <tr className="hover:bg-cyan-50 hover:shadow-md">
      <td className="px-2 py-1 border-b border-white text-center bg-white" />
      <td colSpan={VIEW_COLUMNS.length} className="border">
        <SimpleVirtualizedAutocomplete
          options={customerOptions}
          value={
            customerOptions.find(
              (option) => option.customerID === newCustomerId
            ) || null
          }
          onChange={handleOnChange}
          optionKey="customerID"
          optionLabel="customerName"
          placeholder="Select a customer..."
          itemSize={40}
          maxVisibleItems={8}
          className="w-full py-1 px-2"
        />
      </td>
    </tr>
  );
};

AddCustomerRow.propTypes = {
  customerOptions: PropTypes.array.isRequired,
  addCustomer: PropTypes.func.isRequired,
  newCustomerId: PropTypes.string.isRequired,
  setNewCustomerId: PropTypes.func.isRequired,
};

export default AddCustomerRow;
